import React from 'react';
import { Button } from '../ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-gradient-to-b from-white to-amber-50" data-id="element-102">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-103">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-amber-100" data-id="element-104">
          <div className="bg-stone-900 p-6 text-center" data-id="element-105">
            <h2 className="text-2xl md:text-3xl font-bold text-white font-serif" data-id="element-106">
              The Offer
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-107">
            <div className="space-y-6 mb-10 text-stone-600" data-id="element-108">
              <p className="text-lg" data-id="element-109">
                If you went to a high-end wellness clinic in Florida or
                California, you’d pay{' '}
                <span className="font-bold text-stone-900 decoration-red-500 decoration-2 line-through" data-id="element-110">
                  $350+
                </span>{' '}
                for a metabolic consultation like this.
              </p>
              <p className="text-lg" data-id="element-111">
                You could spend{' '}
                <span className="font-bold text-stone-900 decoration-red-500 decoration-2 line-through" data-id="element-112">
                  $150
                </span>{' '}
                on high-end creams that only mask the problem.
              </p>
              <p className="text-lg font-medium text-amber-700" data-id="element-113">
                But because my mission is to help 10,000 women regain their
                confidence this year...
              </p>
            </div>

            <div className="mb-10 p-6 bg-amber-50 rounded-2xl border border-amber-100 inline-block w-full max-w-lg mx-auto" data-id="element-114">
              <p className="text-stone-500 mb-2 text-sm uppercase tracking-wide" data-id="element-115">
                You won't pay $350. You won't even pay $97.
              </p>
              <p className="text-stone-900 font-bold mb-4" data-id="element-116">
                Get the entire "Golden Root Ritual" Protocol today for a
                one-time payment of:
              </p>

              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-117">
                <span className="text-4xl text-stone-400 line-through font-serif decoration-red-500 decoration-2" data-id="element-118">
                  $97
                </span>
                <span className="text-6xl md:text-7xl font-bold text-amber-600 font-serif" data-id="element-119">
                  $27{' '}
                  <span className="text-xl text-stone-500 font-sans font-normal" data-id="element-120">
                    USD
                  </span>
                </span>
              </div>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-121">
              <Button size="xl" className="w-full md:w-auto shadow-amber-500/30 shadow-xl animate-pulse" showIcon={true} data-id="element-122">
                YES! GIVE ME INSTANT ACCESS
              </Button>

              <div className="flex items-center gap-2 text-sm text-stone-500 mt-4" data-id="element-123">
                <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-124" />
                <span data-id="element-125">Secure Payment • Instant Digital Download</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}